import React from 'react';
import { ArcInputAdornmentProps } from './types';
import { InputAdornment } from '@mui/material';

const ArcInputAdornment: React.FC<ArcInputAdornmentProps> = (props) => {
  return <InputAdornment {...props} />;
};

export default ArcInputAdornment;